import CRUD from "@/firebase/crud";
import store from "@/store/index";

const panel = {
    namespaced: true,
    state: {
        Type: [],
        TypeResult: {},
        Location: [],
        LocationResult: {},
        Clarity: [],
        ClarityResult: {}
    },
    mutations: {
        setType(state, data) { 
            state.Type = data;
        },
        setTypeResult(state, data){
            state.TypeResult = data;
        },
        setLocation(state, data) { 
            state.Location = data;
        },
        setLocationResult(state, data){
            state.LocationResult = data;
        },
        setClarity(state, data) { 
            state.Clarity = data;
        },
        setClarityResult(state, data){
            state.ClarityResult = data;
        },
    },
    actions: {
        readType: async ({ commit }, payload) => {
            try {
              let Collection = payload[0];
              let portalID = payload[1];
              let Mutation = payload[2];
              let Result = Promise.resolve(
                CRUD.ReadDocuments(Collection, portalID, null)
              );
              //console.log("PAAAAYLOAD = " + JSON.stringify(payload, null, 2));
              Result.then(Response => {
                switch (Response.result) {
                  case "success":
                    // // console.log("SUCCESSSSSSSSSSSSSSSSSSS")
                    // // console.log(Response)
                    store.commit(Mutation, Response.data);
                    break;
                  case "failure":
                    store.commit("panel/setTypeResult", Response.message);
                    break;
                  case "error":
                    store.commit("panel/setTypeResult", Response.message);
                    break;
                  default:
                    store.commit("panel/setTypeResult", Response.message);
                    break;
                }
              });
            } catch (err) {
              // console.log("ERRRRRRROR");
              // console.log(err);
            }
          },
          readLocation: async ({ commit }, payload) => {
            try {
              let Collection = payload[0];
              let portalID = payload[1];
              let Mutation = payload[2];
              let Result = Promise.resolve(
                CRUD.ReadDocuments(Collection, portalID, null)
              );
              //console.log("PAAAAYLOAD = " + JSON.stringify(payload, null, 2));
              Result.then(Response => {
                switch (Response.result) {
                  case "success":
                    // // console.log("SUCCESSSSSSSSSSSSSSSSSSS")
                    // // console.log(Response)
                    store.commit(Mutation, Response.data);
                    break;
                  case "failure":
                    store.commit("panel/setLocationResult", Response.message);
                    break;
                  case "error":
                    store.commit("panel/setLocationResult", Response.message);
                    break;
                  default:
                    store.commit("panel/setLocationResult", Response.message);
                    break;
                }
              });
            } catch (err) {
              // console.log("ERRRRRRROR");
              // console.log(err);
            }
          },
          readClarity: async ({ commit }, payload) => {
            try {
              let Collection = payload[0];
              let portalID = payload[1];
              let Mutation = payload[2];
              let Result = Promise.resolve(
                CRUD.ReadDocuments(Collection, portalID, null)
              );
              //console.log("PAAAAYLOAD = " + JSON.stringify(payload, null, 2));
              Result.then(Response => {
                switch (Response.result) {
                  case "success":
                    // // console.log("SUCCESSSSSSSSSSSSSSSSSSS")
                    // // console.log(Response)
                    store.commit(Mutation, Response.data);
                    break;
                  case "failure":
                    store.commit("panel/setClarityResult", Response.message);
                    break;
                  case "error":
                    store.commit("panel/setClarityResult", Response.message);
                    break;
                  default:
                    store.commit("panel/setClarityResult", Response.message);
                    break;
                }
              });
            } catch (err) {
              // console.log("ERRRRRRROR");
              // console.log(err);
            }
          }
    }
}

export default panel;